import { render, staticRenderFns } from "./MusicItem.vue?vue&type=template&id=4a839f1b&"
import script from "./MusicItem.vue?vue&type=script&lang=js&"
export * from "./MusicItem.vue?vue&type=script&lang=js&"
import style0 from "./MusicItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports